export enum BdDunningActionTiming {
    INSTANTLY,
    DEFERRED
}

/**
 * German UI labels for BdDunningActionTiming values.
 * INSTANTLY(0)="Sofort", DEFERRED(1)="Vorgemerkt/Freigabe".
 */
export const BD_DUNNING_ACTION_TIMING_LABELS: Record<BdDunningActionTiming, string> = {
    [BdDunningActionTiming.INSTANTLY]: 'Sofort',
    [BdDunningActionTiming.DEFERRED]: 'Vorgemerkt/Freigabe'
};
